import { ranking } from "@/mocks/homeData";

const barWidth = ["w-[96%]", "w-[90%]", "w-[85%]", "w-[80%]", "w-[74%]", "w-[68%]", "w-[62%]", "w-[56%]", "w-[50%]", "w-[44%]"];
const topStyle = ["bg-primary-500", "bg-primary-400", "bg-accent-500"];

export default function RankBoard() {
  return (
    <section id="ranking" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-[0.68fr_1.32fr]">
          <div className="flex flex-col justify-between rounded-2xl border border-background-200 bg-primary-900 p-6 text-background-100 md:p-8">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
                <i className="ri-line-chart-line" aria-hidden="true"></i>每小时刷新
              </span>
              <h2 className="mt-4 text-2xl font-black tracking-tight text-background-50 md:text-3xl">
                全网围观榜
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                热度值综合搜索指数、讨论量与分享量计算，只反映网络关注趋势，不代表事件对错。
              </p>
            </div>
            <div className="mt-8 grid grid-cols-3 gap-3 border-t border-primary-800 pt-5">
              <div>
                <p className="text-xl font-black text-accent-300">24h</p>
                <p className="text-xs text-background-300">每时更新</p>
              </div>
              <div>
                <p className="text-xl font-black text-accent-300">10</p>
                <p className="text-xs text-background-300">上榜话题</p>
              </div>
              <div>
                <p className="text-xl font-black text-accent-300">7</p>
                <p className="text-xs text-background-300">覆盖栏目</p>
              </div>
            </div>
          </div>

          <ol className="flex flex-col gap-2.5">
            {ranking.map((r, i) => (
              <li
                key={r.rank}
                className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3 transition-colors hover:border-primary-200 md:gap-4"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                    i < 3 ? `${topStyle[i]} text-background-50` : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  {r.rank}
                </span>
                <span className="hidden w-14 shrink-0 rounded bg-accent-100 px-1.5 py-0.5 text-center text-[11px] font-semibold text-accent-800 sm:inline-block">
                  {r.tag}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-foreground-950 md:text-base">{r.title}</p>
                  <div className="mt-1.5 h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${i < 3 ? "bg-primary-500" : "bg-secondary-300"} ${barWidth[i]}`}
                    ></div>
                  </div>
                </div>
                <div className="flex shrink-0 items-center gap-2 md:gap-3">
                  <span className="text-sm font-bold text-primary-600">{r.heat}</span>
                  <span
                    className={`flex h-6 w-6 items-center justify-center rounded-full ${
                      r.delta === "up"
                        ? "bg-primary-100 text-primary-600"
                        : r.delta === "down"
                        ? "bg-secondary-100 text-secondary-600"
                        : "bg-background-200 text-foreground-500"
                    }`}
                    title={r.delta === "up" ? "热度上升" : r.delta === "down" ? "热度下降" : "热度平稳"}
                  >
                    <i
                      className={`text-sm ${
                        r.delta === "up"
                          ? "ri-arrow-up-line"
                          : r.delta === "down"
                          ? "ri-arrow-down-line"
                          : "ri-equal-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}